
import React from "react";
import { Grid, Card, Box, Typography } from "@mui/material";
export default function Analytics({ data, title }) {
  const cover = {
    width: 40, height: '100%', textAlign: 'center', color: 'gray', display: 'flex',
    alignItems: 'flex-end',
  }
  const cs = { width: 40, height: '100%', background: '#227d52', borderRadius: 100, position: 'relative' }
  const csz = { ...cs, backgroundImage: 'repeating-linear-gradient(135deg, gray 0px, gray 2px, white 0px, white 4px)' }
  const labelcss = { color: 'gray', position: 'absolute', bottom: -18, left: 0, right: 0, margin: 'auto', textAlign: 'center' }
  data = data ? data : { S: { value: 30 }, M: { value: 60 }, T: {value:70}, W: {}, TH: {value:20}, F: {}, ST: {value:80} }
  Object.keys(data).map((key) => {
    let v = data[key]?.value
    data[key].css = {...csz}
    if (v > 0) {
      data[key].css = {...cs}
    }
    if (v > 50) {
      data[key].css = {...cs,background:'#075b33'}
    }
    if (v > 0) {
      data[key].css.height = `${v}%`
      
    }
  })

  return <>
    <Box
      sx={{
        p: 3,
        bgcolor: 'background.paper',
        borderRadius: 4,
        fontSize: 12,
        display: 'inline-block'
      }}
    >
      <Typography>{title}</Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-end',
          bgcolor: 'background.paper',
          height: 100,
          gap: 2,
          my: 1
        }}
      >
        {Object.keys(data).map((key, i) => {
          let csss = data[key]?.css ? data[key]?.css : csz
          return <Box sx={csss}><Box sx={labelcss}>{key}</Box></Box>
        })}
      </Box>
    </Box>
  </>
}